// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

export default {
  Alert: {
    close: 'Close'
  },
  Card: {
    select: 'Chọn',
    titleLinkTooltip: 'Đi tới trang',
    collapseCardTooltip: 'Thu gọn thẻ',
    expandCardTooltip: 'Mở rộng thẻ'
  },
  CardList: {
    loadMore: 'Tải thêm',
    notFound: 'Không tìm thấy mục nào.',
    toolbarSelect: 'Chọn',
    viewCards: 'Thẻ',
    viewTiles: 'Ô',
    viewList: 'Danh sách',
    toolbarView: 'Chế độ xem'
  },
  Carousel: {
    nextSlide: 'Next slide',
    previousSlide: 'Previous slide',
    viewSlide: 'View slide %%slideNumber%%'
  },
  ComboBox: {
    close: 'Close',
    open: 'Open'
  },
  ClosingConfirmation: {
    confirm: 'Rời đi',
    cancel: 'Quay lại',
    content: 'Bạn có chắc muốn đóng và rời khỏi cửa sổ này không? Mọi thay đổi về dữ liệu bạn đã thực hiện sẽ không được lưu.'
  },
  Cuttable: {
    showMore: 'Hiện thêm',
    showLess: 'Ẩn bớt'
  },
  Dialog: {
    closeButton: 'Close',
    cancelButton: 'Hủy'
  },
  Drawer: {
    backButton: 'Back',
    closeButton: 'Close',
    hideButton: 'Hide'
  },
  DrawerProgress: {
    cancelButton: 'Hủy'
  },
  Dropdown: {
    close: 'Đóng'
  },
  Form: {
    submitButton: 'Lưu',
    applyButton: 'Áp dụng',
    cancelButton: 'Hủy'
  },
  FormField: {
    clear: 'Xóa',
    remove: 'Gỡ bỏ',
    addMore: 'Thêm một mục',
    showDescription: 'Show description'
  },
  FormFieldPassword: {
    improvePassword: 'Để tăng độ khó cho mật khẩu:',
    passwordTooShort: 'Dùng mật khẩu dài hơn.',
    lettersLowerCase: 'Sử dụng ít nhất một ký tự viết thường.',
    lettersUpperCase: 'Sử dụng ít nhất một ký tự viết hoa.',
    numbers1: 'Sử dụng ít nhất một số.',
    numbers3: 'Sử dụng ít nhất ba số.',
    specialChar1: 'Sử dụng ít nhất một ký tự đặc biệt (ví dụ: !, @, #, $, %, ^, &, *, ?, _, ~).',
    specialChar2: 'Sử dụng ít nhất hai ký tự đặc biệt (ví dụ: !, @, #, $, %, ^, &, *, ?, _, ~).',
    comboUpperAndLower: 'Sử dụng cả ký tự viết hoa và thường.',
    comboLettersAndNumbers: 'Sử dụng cả số và ký tự.',
    comboLettersNumbersSpecial: 'Sử dụng số, ký tự và ký tự đặc biệt.',
    yourPasswordIsStrong: 'Bạn có thể tăng độ khó bằng cách đặt mật khẩu dài.',
    passwordStrength: 'Độ mạnh của mật khẩu là %%strength%%.',
    strengthVeryStrong: 'RẤT MẠNH',
    strengthStrong: 'MẠNH',
    strengthVeryWeak: 'RẤT YẾU',
    strengthWeak: 'YẾU',
    strengthMedium: 'TRUNG BÌNH',
    hidePassword: 'Ẩn mật khẩu',
    showPassword: 'Hiện mật khẩu',
    generateButton: 'Khởi tạo',
    copyButtonHint: 'Sao chép mật khẩu',
    copySuccessToast: 'Mật khẩu đã được sao chép',
    generateButtonHint: 'Khởi tạo một mật khẩu mạnh'
  },
  InPlaceEdit: {
    cancelButtonHint: 'Hủy bỏ thay đổi',
    editButtonHint: 'Chỉnh sửa giá trị',
    okButtonHint: 'Lưu thay đổi'
  },
  InputNumber: {
    decrement: 'Decrement',
    increment: 'Increment'
  },
  InputFile: {
    browseButton: 'Chọn tập tin...'
  },
  Layout: {
    openSidebar: 'Expand sidebar',
    closeSidebar: 'Collapse sidebar'
  },
  List: {
    totalRows: 'Tổng cộng %%totalRows%% mục',
    toggleAllRows: 'Toggle all rows',
    toggleRow: 'Toggle row',
    selectedRows: 'Đã chọn %%selectedRows%% trong số %%totalRows%% mục',
    all: 'Tất cả',
    allItemsOnPageSelected: 'Đã chọn tất cả mục trên trang',
    allItemsSelected: 'Đã chọn tất cả mục',
    selectAllItems: 'Chọn tất cả mục',
    selectAllItemsOnPage: 'Chọn tất cả mục trên trang',
    deselectAll: 'Bỏ chọn',
    selectRow: 'Select row',
    selectAllRows: 'Select all rows'
  },
  ListActions: {
    menuButton: 'Open menu'
  },
  ListEmptyView: {
    filteredTitle: 'Không tìm thấy mục nào phù hợp với bộ lọc',
    emptyTitle: 'Dường như không có gì ở đây',
    filteredDescription: 'Tinh chỉnh truy vấn của bạn hoặc xóa một số tiêu chí khỏi bộ lọc và thử lại.'
  },
  ListOperation: {
    cancelButton: 'Hủy'
  },
  Panel: {
    collapse: 'Collapse',
    expand: 'Expand'
  },
  Pagination: {
    totalShort: 'trên %%total%%',
    itemsPerPage: 'Mục mỗi trang',
    all: 'Tất cả',
    total: 'Trang %%current%% trên %%total%%'
  },
  Popover: {
    closeButton: 'Close'
  },
  ProgressDialog: {
    closeButton: 'Đóng',
    cancelButton: 'Hủy'
  },
  Section: {
    collapse: 'Collapse',
    closeButton: 'Close',
    expand: 'Expand'
  },
  Select: {
    clearButton: 'Clear',
    noOptions: 'Không có tùy chọn',
    placeholder: 'Chọn...'
  },
  SearchBar: {
    clearButton: 'Clear',
    searchButton: 'Search',
    collapseSearch: 'Hide search input',
    expandSearch: 'Show search input'
  },
  SpotPopup: {
    total: '%%current%% trên %%total%%'
  },
  SwitchesPanelItem: {
    showDescription: 'Show description'
  },
  Tabs: {
    closeButton: 'Close tab'
  },
  Toaster: {
    closeGroup: 'Đóng nhóm'
  },
  Toast: {
    closeButton: 'Close'
  }
};